import { render, staticRenderFns } from "./deductionDetail.vue?vue&type=template&id=63a54a76&scoped=true"
import script from "./deductionDetail.vue?vue&type=script&lang=js"
export * from "./deductionDetail.vue?vue&type=script&lang=js"
import style0 from "./deductionDetail.vue?vue&type=style&index=0&id=63a54a76&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a54a76",
  null
  
)

export default component.exports